
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'NotFoundView',
})
export default class NotFoundView extends Vue {}

